<div class="lieferant-page">
    <ng-container *ngIf="isMobileScreen; else desktopHeader">
        <div class="list-title-row list-title-row--mobile">
            <button *ngIf="showReturnButton" mat-icon-button color="accent" (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <h3 class="mobile-title">Meine Futtermittellieferanten ({{ getSortedLieferanten().length || 0 }})</h3>
            <span class="spacer"></span>
            <button (click)="futtermittellieferantHinzufuegen()" color="accent" mat-icon-button>
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </ng-container>
    <ng-template #desktopHeader>
        <kiene-page-header
            *ngIf="showReturnButton"
            [showReturnButton]="showReturnButton"
            [ueberschrift]="'Meine Futtermittellieferanten'"
            [routeRelativeAlternative]="'../../'"
        ></kiene-page-header>
        <div class="list-title-row">
            <h3 class="list-title">Futtermittellieferanten ({{ getSortedLieferanten().length || 0 }})</h3>
            <span class="spacer"></span>
            <button (click)="futtermittellieferantHinzufuegen()" color="accent" mat-icon-button>
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </ng-template>

    <div class="mobile-cards" *ngIf="isMobileScreen && getSortedLieferanten().length; else desktopOrEmpty">
        <div class="mobile-card" *ngFor="let lieferant of getSortedLieferanten()">
            <div class="mobile-card__header">
                <div class="mobile-card__title-wrap">
                    <div class="mobile-card__title">{{ lieferant?.bezeichnung || '-' }}</div>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="lieferantMenuMobile" class="options-button">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #lieferantMenuMobile="matMenu" xPosition="before" yPosition="below">
                    <button mat-menu-item *ngIf="lieferant?.futtermittellieferant_id" (click)="loescheLieferant(lieferant)">
                        <mat-icon>delete</mat-icon>
                        <span>Löschen</span>
                    </button>
                </mat-menu>
            </div>
            <div class="mobile-card__grid">
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Ort</span>
                    <span class="mobile-card__value">{{ lieferant?.ort || '-' }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">QS-ID</span>
                    <span class="mobile-card__value">{{ lieferant?.qs_id || '-' }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Kontakt</span>
                    <span class="mobile-card__value">{{ lieferant?.telefon || lieferant?.email || '-' }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Kunde</span>
                    <span class="mobile-card__value">{{ lieferant?.verbundene_kunden || '-' }}</span>
                </div>
            </div>
        </div>
    </div>

    <ng-template #desktopOrEmpty>
        <div class="list-wrapper" *ngIf="getSortedLieferanten().length; else noBetriebe">
            <div class="list-header">
                <button class="sort-header" type="button" (click)="setSort('bezeichnung')">
                    Name
                    <mat-icon class="sort-icon" *ngIf="sortField === 'bezeichnung'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('ort')">
                    Ort
                    <mat-icon class="sort-icon" *ngIf="sortField === 'ort'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('qs_id')">
                    QS-ID
                    <mat-icon class="sort-icon" *ngIf="sortField === 'qs_id'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <span>Kunde</span>
                <span></span>
            </div>

            <ng-container *ngFor="let lieferant of getSortedLieferanten()">
                <div class="list-row">
                    <span>
                        <span class="mobile-field-label">Name:</span>
                        <span class="mobile-field-value">{{ lieferant?.bezeichnung || '-' }}</span>
                    </span>
                    <span>
                        <span class="mobile-field-label">Ort:</span>
                        <span class="mobile-field-value">{{ lieferant?.ort || '-' }}</span>
                    </span>
                    <span>
                        <span class="mobile-field-label">QS-ID:</span>
                        <span class="mobile-field-value">{{ lieferant?.qs_id || '-' }}</span>
                    </span>
                    <span>
                        <span class="mobile-field-label">Kunde:</span>
                        <span class="mobile-field-value">{{ lieferant?.verbundene_kunden || '-' }}</span>
                    </span>
                    <span class="row-actions">
                        <button mat-icon-button [matMenuTriggerFor]="lieferantMenu" class="options-button">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #lieferantMenu>
                            <button mat-menu-item *ngIf="lieferant?.futtermittellieferant_id" (click)="loescheLieferant(lieferant)">
                                <mat-icon>delete</mat-icon>
                                <span>Löschen</span>
                            </button>
                        </mat-menu>
                    </span>
                </div>
            </ng-container>
        </div>
    </ng-template>

    <ng-template #noBetriebe>
        <div class="empty-state">Kein Futtermittellieferant verbunden.</div>
    </ng-template>
</div>
